import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-commonselect',
  templateUrl: './commonselect.component.html',
  styleUrls: ['./commonselect.component.css']
})
export class CommonselectComponent implements OnInit {
  @Input() selectOptionsArr = []
  @Input() selectArr = []
  @Input()  selectedValue: string;
  @Output() onSelectChange = new EventEmitter<string>();
  constructor(private router: Router){
}

  ngOnInit(): void {
    //console.log(this.router.url);
    // console.log(this.selectedValue)
    // console.log(this.selectOptionsArr)
    //console.log(this.selectArr);
    this.selectedValue;
   
    
  }

  onSelectChanges(event) {
   // console.log(event.target.value,"common select");
    this.onSelectChange.emit(event.target.value)
  }

}
